<template>
  <v-container>
    <v-row>
      <v-col>
        <p>Logging out...</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  mounted() {
    this.$app.authCommonAdapter.invalidateTokenSet();
  },
};
</script>
